export class Ciudad {
  idCiudad: number;
  nombreCiudad: string;
  codigoIATA: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ciudad.ts